<script setup lang="ts">
    import { toRefs } from "vue";
    import KAutocomplete from "../inputs/Autocomplete/KAutocomplete.vue";

    interface Props {
        name: string;
        label: string;
        includeOkand?: boolean;
        ignoreEmptyData?: boolean;
        /**
         * Ska ja/nej konverteras till boolean?
         * OBS! Använd inte tillsammans med includeOkand. Det kommer konverteras till false
         */
        toBoolean?: boolean;
        shouldBeVisible?: boolean;
    }
    const props = withDefaults(defineProps<Props>(), {
        includeOkand: false,
        toBoolean: false,
        shouldBeVisible: undefined,
    });
    const { name, label, includeOkand } = toRefs(props);

    const jaNejOptions = [
        { label: "Ja", value: "JA" },
        { label: "Nej", value: "NEJ" },
        ...(includeOkand.value ? [{ label: "Okänd", value: "OKAND" }] : []),
    ];

    const booleanConverter = ({ value }: { value: unknown }) => {
        const typedValue = value as string;

        return typedValue && typedValue.toLowerCase() === "ja";
    };
</script>

<template>
    <KAutocomplete
        v-bind="$attrs"
        :name="name"
        :label="label"
        :options="jaNejOptions"
        :ignoreEmptyData="ignoreEmptyData"
        :converter="toBoolean ? booleanConverter : undefined"
        :shouldBeVisible="shouldBeVisible"
    />
</template>

<style lang="scss" scoped></style>
